
//使用mockjs的模板生成随机数据
const data = {
    "code": 200,
    "data": [
        {
            "id": "6",
            "time": 358,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105006"
        },
        {
            "id": "12",
            "time": 321,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105012"
        },
        {
            "id": "24",
            "time": 287,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105024"
        },
        {
            "id": "3",
            "time": 235,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105003"
        },
        {
            "id": "7",
            "time": 199,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105007"
        },
        {
            "id": "33",
            "time": 187,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105033"
        },
        {
            "id": "5",
            "time": 179,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105005"
        },
        {
            "id": "20",
            "time": 179,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105020"
        },
        {
            "id": "15",
            "time": 162,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105015"
        },
        {
            "id": "28",
            "time": 155,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105028"
        },
        {
            "id": "37",
            "time": 154,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105037"
        },
        {
            "id": "2",
            "time": 153,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105002"
        },
        {
            "id": "21",
            "time": 152,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105021"
        },
        {
            "id": "8",
            "time": 151,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105008"
        },
        {
            "id": "18",
            "time": 147,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105018"
        },
        {
            "id": "11",
            "time": 141,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105011"
        },
        {
            "id": "35",
            "time": 135,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105035"
        },
        {
            "id": "26",
            "time": 133,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105026"
        },
        {
            "id": "10",
            "time": 122,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105010"
        },
        {
            "id": "1",
            "time": 119,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105001"
        },
        {
            "id": "34",
            "time": 116,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105034"
        },
        {
            "id": "30",
            "time": 115,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105030"
        },
        {
            "id": "27",
            "time": 110,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105027"
        },
        {
            "id": "23",
            "time": 109,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105023"
        },
        {
            "id": "31",
            "time": 107,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105031"
        },
        {
            "id": "14",
            "time": 103,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105014"
        },
        {
            "id": "17",
            "time": 100,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105017"
        },
        {
            "id": "9",
            "time": 96,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105009"
        },
        {
            "id": "36",
            "time": 80,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105036"
        },
        {
            "id": "16",
            "time": 78,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105016"
        },
        {
            "id": "32",
            "time": 77,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105032"
        },
        {
            "id": "4",
            "time": 68,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105004"
        },
        {
            "id": "22",
            "time": 65,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105022"
        },
        {
            "id": "13",
            "time": 32,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105013"
        },
        {
            "id": "19",
            "time": 12,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105019"
        },
        {
            "id": "38",
            "time": 12,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105038"
        },
        {
            "id": "29",
            "time": 8,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105029"
        },
        {
            "id": "25",
            "time": 5,
            "device_name": "T5多功能康复休憩沙发",
            "device_id": "159105025"
        }
    ],
    "message": "success"
}
export default data;

